<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addBdmItem('video')">新增视频资源</el-button>
      <el-button type="primary" size="medium" @click="addBdmItem('image')">新增图片资源</el-button>
      <el-checkbox :indeterminate="isIndeterminate" v-model="allChecked" label="全选" border @change="checkAllChange"
        size="medium" :disabled="total <= 0"></el-checkbox>
      <el-button plain type="danger" :disabled="isSel ? false : true" size="medium"
        @click="delBdmItemList">删除</el-button>
    </div>
    <div class="tab-content">
      <el-checkbox-group v-model="checkedActiveList" @change="checkedActiveChange">
        <el-table :data="activeList" style="width: 100%" :max-height="550">
          <el-table-column align="left" label="资源名称">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row.bdmItemId">
                <div>
                  {{ scope.row.itemName }}
                </div>
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="itemImage" label="资源封面" width="380">
            <template slot-scope="scope">
              <img class="item-img" :src="scope.row.itemImage" alt="" />
            </template>
          </el-table-column>
          <el-table-column align="center" prop="itemType" label="资源类型">
            <template slot-scope="scope">
              {{
                scope.row.itemType == 10
                  ? "商户活动信息资源"
                  : scope.row.itemType == 20
                    ? "商家发布视频资源"
                    : scope.row.itemType == 30
                      ? "顾客转发视频资源"
                      : scope.row.itemType == 70
                        ? "商家图片资源"
                        : ""
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="资源" width="380">
            <template slot-scope="scope">
              <!-- previewVideo(scope.row.itemLink) -->
              <el-button type="primary" size="small" @click="handlePreview(scope.row)">预览</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="isUsed" label="使用情况">
            <template slot-scope="scope">
              <span :class="{
                'text-red-500': scope.row.isUsed == 1 || scope.row.isUsed == 20,
                'text-green-500': scope.row.isUsed == 0,
              }">{{ isUsedType[scope.row.isUsed] }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="delActive(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
    </div>
    <div v-show="activeList.length > 0" style="padding-left: 15px">
      <el-pagination @current-change="handleCurrentChange" :page-size="queryInfo.row" :current-page="queryInfo.pageNo"
        background layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
    <div class="popup" :class="{ show: isShowVideo }">
      <div class="popup-content">
        <div class="popup-header">
          <span>视频预览</span>
          <img class="close" src="../assets/img/icon-close-dark.png" alt="" @click="isShowVideo = false" />
        </div>
        <div class="popup-container">
          <video autoplay="autoplay" controls="controls" :src="videoPreView"></video>
        </div>
      </div>
    </div>
    <div class="popup" :class="{ show: isShowImage }">
      <div class="popup-content">
        <div class="popup-header">
          <span>图片预览</span>
          <img class="close" src="../assets/img/icon-close-dark.png" alt="" @click="isShowImage = false" />
        </div>
        <div class="image-preview-container">
          <!-- <img :src="imagePreviewUrl" alt="预览图片" /> -->
          <button v-if="imagePreviewUrls.length > 1 && currentImageIndex > 0" class="nav-button prev"
            @click="prevImage">‹</button>
          <img :src="imagePreviewUrls[currentImageIndex]" :alt="`预览图片 ${currentImageIndex + 1}`" />
          <button v-if="imagePreviewUrls.length > 1 && currentImageIndex < imagePreviewUrls.length - 1"
            class="nav-button next" @click="nextImage">›</button>
          <div class="image-indicators" v-if="imagePreviewUrls.length > 1">
            <span v-for="(url, index) in imagePreviewUrls" :key="index" :class="{ active: index === currentImageIndex }"
              @click="currentImageIndex = index"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBdmItemList,
  getBdmItemListCount,
  delBdmItem,
  delBdmItemList,
} from "../api/index";
let activeListOptions = [];
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      activeList: [],
      videoPreView: "",
      isShowVideo: false,
      allChecked: false,
      isIndeterminate: false,
      isSel: false,
      checkedActiveList: [],
      isUsedType: {
        0: "未使用",
        1: "已使用",
        20: "已锁定",
      },

      isShowImage: false,
      imagePreviewUrl: '',
      imagePreviewUrls: [],
      currentImageIndex: 0,
    };
  },
  mounted() {
    if (!this.$route.query.activityId) {
      return this.$notify({
        title: "提示",
        message: "缺少必要参数",
        type: "warning",
        duration: 3000,
      });
    }
    this.getBdmItemList();
  },
  methods: {
    getBdmItemList() {
      getBdmItemList({
        activityId: this.$route.query.activityId,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        activeListOptions = [];
        if (res.code == 1) {
          this.activeList = res.data;
          res.data.forEach((val) => {
            activeListOptions.push(val.bdmItemId);
          });
        } else if (res.code == -1) {
          this.activeList = [];
          if (this.queryInfo.pageNo > 1) {
            this.queryInfo.pageNo--;
            this.getBdmItemList();
          }
        }
        this.checkAllChange(false);
      });
      getBdmItemListCount({
        activityId: this.$route.query.activityId,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        if (res.code == 1) {
          this.total = res.data.totalNum;
        } else {
          this.total = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getBdmItemList();
    },
    addBdmItem(type) {
      this.$router.push(
        `/marketing/bdmItemAdd?activityId=${this.$route.query.activityId}&type=${type}`
      );
    },
    delActive(row) {
      console.log(row, "delActive");
      this.$confirm("此操作将永久删除该资源, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delBdmItem({
          activityId: row.shopActivityId,
          bdmItemId: row.bdmItemId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getBdmItemList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    delBdmItemList() {
      this.$confirm("此操作将永久删除资源, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delBdmItemList({
          activityId: this.$route.query.activityId,
          bdmItemIdJson: JSON.stringify(this.checkedActiveList),
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            // this.queryInfo.pageNo = 1;
            this.getBdmItemList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    previewVideo(url) {
      this.videoPreView = url;
      this.isShowVideo = true;
    },
    handlePreview(data) {
      if (data.itemType == 20) {
        this.videoPreView = data.itemLink;
        this.isShowVideo = true;
      } else if (data.itemType == 70) {
        // 显示预览图片组
        // this.imagePreviewUrls = data.itemImages ? data.itemImages.split(',') : [];
        // this.currentImageIndex = 0;
        // this.isShowImage = true;

        // 处理多图预览
        // 假设 itemImages 是包含多个图片URL的数组或逗号分隔的字符串
        if (Array.isArray(data.itemImages)) {
          this.imagePreviewUrls = data.itemImages;
        } else if (typeof data.itemImages === 'string') {
          this.imagePreviewUrls = data.itemImages.split(',');
        } else {
          this.imagePreviewUrls = [data.itemImage];
        }
        this.currentImageIndex = 0;
        this.isShowImage = true;
      }
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.imagePreviewUrls.length - 1) {
        this.currentImageIndex++;
      }
    },
    checkedActiveChange(value) {
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.activeList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.activeList.length;
      this.isSel = checkedCount > 0;
    },
    checkAllChange(val) {
      this.checkedActiveList = val ? activeListOptions : [];
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .item-img {
    width: 100px;
  }

  .tab-header {
    .el-checkbox {
      margin: 0 15px;
    }
  }

  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }

  .text-red {
    color: red;
  }

  .text-green {
    color: green;
  }

  .popup-container {
    width: 1000px;
    height: 500px;
    padding: 10px;
    text-align: center;

    video {
      box-sizing: border-box;
      height: 100%;
    }
  }
}

// 在样式部分添加图片预览样式
.popup-container {
  width: 1000px;
  height: 500px;
  padding: 10px;
  text-align: center;

  video {
    box-sizing: border-box;
    height: 100%;
    max-width: 100%;
  }
}

// 图片预览容器样式
.image-preview-container {
  width: 1000px;
  height: 500px;
  padding: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

// 弹窗基础样式优化
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &.show {
    display: flex;
  }

  .popup-content {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #eee;
      background-color: #f8f9fa;

      span {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }

      .close {
        width: 24px;
        height: 24px;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: rotate(90deg);
        }
      }
    }
  }
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 24px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;

  &.prev {
    left: 20px;
  }

  &.next {
    right: 20px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
}

.image-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;

  span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;

    &.active {
      background: white;
    }
  }
}
</style>
